/* istanbul ignore file */
import useCodeNameService from './codeNameService';
import { useFormContext } from 'framework/form';
import { Button } from 'framework/ui/mui-builder';
import { get } from 'lodash';

interface GenerateCodeNameButtonProps {
  source: string;
  isVisible: boolean;
  setCodeNameMethod: (codeName: string) => void;
  color?: BasicColors | undefined;
}

const GenerateCodeNameButton = ({
  source,
  isVisible = false,
  setCodeNameMethod,
  color = 'secondary',
}: GenerateCodeNameButtonProps) => {
  const { isGrantedToGenerateCodeName, generateCodeName } = useCodeNameService();
  const { data = {} } = useFormContext();
  const name = get(data, source);

  const isGranted = isGrantedToGenerateCodeName();
  const buttonText = !name ? 'Generate code name' : 'Regenerate code name';

  const onClick = async () => {
    const newCodeName = await generateCodeName(name);
    setCodeNameMethod(newCodeName.name);
  };

  return isGranted && isVisible ? (
    <Button onClick={onClick} key="btn-generate-code-name" color={color}>
      {buttonText}
    </Button>
  ) : null;
};

export default GenerateCodeNameButton;
